import { Link } from "gatsby";
import styled from "styled-components";

export const SearchTitleRoot = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;

    ${({ theme }) => theme.breakpoints.md.mediaquery} {
        padding: 20px 0 35px;
    }
`;

export const Title = styled.h1`
    color: ${({ theme }) => theme.colors.porscheBankBlue};
    margin: 0;
    font-size: 20px;

    ${({ theme }) => theme.breakpoints.md.mediaquery} {
        padding: 0 20px;
        font-size: 32px;
    }
    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        padding: 0;
    }
`;

export const SearchSortContainer = styled.div`
    display: none;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        display: block;
        width: 250px;
    }
`;

export const HeaderRoot = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundLightGray};
    margin: 0 20px;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        margin: 30px 30px 0;
        border-bottom: 2px solid ${({ theme }) => theme.colors.backgroundLightGray};
    }

    ${({ theme }) => theme.breakpoints.xl.mediaquery} {
        margin: 30px 0 0 30px;
    }
`;

export const Tabs = styled.div`
    display: flex;
    font-weight: 700;
    width: 100%;
    justify-content: center;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        justify-content: flex-start;
        margin-bottom: -2px;
    }
`;

export const Tab = styled.div`
    padding: 10px 0;
    color: ${({ theme }) => theme.colors.porscheBankBlue};
    text-align: center;
    font-weight: 600;
    border-bottom: 2px solid ${({ theme }) => theme.colors.porscheBankBlue};
    font-size: 16px;
    line-height: 22px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-basis: 50%;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        padding: 15px 30px;
        flex-basis: 250px;
        text-align: left;
        font-size: 18px;
        line-height: 30px;
    }
`;

export const TabLink = styled(Link)`
    padding: 10px 0;
    color: ${({ theme }) => theme.colors.porscheBankBlue};
    text-decoration: none;
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex-basis: 50%;

    ${({ theme }) => theme.breakpoints.lg.mediaquery} {
        padding: 15px 30px;
        flex-basis: 250px;
        text-align: left;
        font-size: 18px;
        line-height: 30px;
    }
`;
